import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { saveNotificationFunction } from "../../services/notification_functions";

import { ISaveNotificationFunction } from "../../types/custom_notifications";

interface IPayload {
    data: ISaveNotificationFunction;
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
};

const useSaveNotificationFunction = () => {
    const queryClient = useQueryClient();

    const mutationFn = async (payload: IPayload) => {
        return await saveNotificationFunction(payload.data);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
            variables.setApiError(null);
        },
        onSuccess: (status: number, variables: IPayload) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["custom_notifications"] });
                toast.success("Notification Function saved successfully!");
            }
            variables.setIsProcessing(false);
            variables.setApiError(null);
        },
        onError: (error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            variables.setApiError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        },
        onSettled: (status: number | undefined, error: any, variables: IPayload) => {
            if (status === 200) {
                variables.setIsProcessing(false);
                variables.setApiError(null);
            }
        }
    });
};
export default useSaveNotificationFunction;